/**
 * 此页用于定义权限相关函数
 * (scope:state里的scope数据)=>boolean
 *
 * 返回值说明
 * true - 隐藏
 * false - 显示
 */

// 针对【非平台用户】隐藏
export const pPlatformUser = scope => {
    // 角色类型
    const { type } = scope;
    // 平台使用 | 平台管理
    if (type === 2 || type === 3) return false;
    else return true;
};
